<template>
  <component
    :is="baseComponent"
    :to="link.path ? link.path : '/'"
    :class="{ active: isActive }"
    tag="li"
  >
    <a
      v-if="isMenu"
      href="#"
      class="nav-link sidebar-menu-item"
      :aria-expanded="!collapsed"
      data-toggle="collapse"
      @click.prevent="collapseMenu"
    >
      <i :class="link.icon"></i>
      <p>
        {{ link.name }}
        <b class="caret"></b>
      </p>
    </a>
    <collapse-transition>
      <div v-if="$slots.default || this.isMenu" v-show="!collapsed">
        <ul class="nav links__nav">
          <slot></slot>
        </ul>
      </div>
    </collapse-transition>

    <slot name="title" v-if="children.length === 0 && !$slots.default && link.path">
      <component :to="link.path" @click.native="linkClick"
        :is="elementType(link, false)" :class="{ active: link.active }"
        class="nav-link" :target="link.target" href="#">
        <template v-if="addLink">
          <i v-if="link.icon !== undefined" :class="link.icon"></i>
          <span v-if="link.icon === undefined" class="sidebar-mini-icon">{{ linkPrefix }}</span>
          <span class="sidebar-normal">{{ link.name }}</span>
          <div class="filters">
            <div style="width: 108px; margin-top: 5px;">
              <span @click.stop="linkClickWithFilter('todo')" class="filter-tag badge badge-pill badge-default" v-show="filtersNumber.todo > 0">{{filtersNumber.todo}}</span>
              <span @click.stop="linkClickWithFilter('prepared')" class="filter-tag badge badge-pill badge-info" v-show="filtersNumber.prepared > 0">{{filtersNumber.prepared}}</span>
              <span @click.stop="linkClickWithFilter('standby')" class="filter-tag badge badge-pill badge-warning" v-show="filtersNumber.standby > 0">{{filtersNumber.standby}}</span>
              <span @click.stop="linkClickWithFilter('urgent')" class="filter-tag badge badge-pill badge-danger" v-show="filtersNumber.urgent > 0">{{filtersNumber.urgent}}</span>
              <span @click.stop="linkClickWithFilter('subcontract')" class="filter-tag badge badge-pill badge-subcontract" v-show="filtersNumber.subcontract > 0">{{filtersNumber.subcontract}}</span>
            </div>
          </div>
        </template>
        <template v-else>
          <i :class="link.icon"></i>
          <p>{{ link.name }}</p>
        </template>
      </component>
    </slot>
  </component>
</template>
<script>
import { CollapseTransition } from "vue2-transitions";

export default {
  name: "sidebar-item",
  components: {
    CollapseTransition,
  },
  props: {
    menu: {
      type: Boolean,
      default: false,
    },
    opened: {
      type: Boolean,
      default: false,
    },
    link: {
      type: Object,
      default: () => {
        return {
          name: "",
          path: "",
          children: [],
        };
      },
    },
    filtersNumber: {
      type: Object,
      default: () => {
        return {
          todo: 0,
          prepared: 0,
          standby: 0,
          urgent: 0,
          default: '5',
        }
      },
    },
  },
  provide() {
    return {
      addLink: this.addChild,
      removeLink: this.removeChild,
    };
  },
  inject: {
    addLink: { default: null },
    removeLink: { default: null },
    autoClose: {
      default: true,
    },
  },
  data() {
    return {
      children: [],
      collapsed: !this.opened,
    };
  },
  computed: {
    baseComponent() {
      return this.isMenu || this.link.isRoute ? "li" : "router-link";
    },
    linkPrefix() {
      if (this.link.name) {
        let words = this.link.name.split(" ");
        return words.map((word) => word.substring(0, 1)).join("");
      } else {return true}
    },
    isMenu() {
      return this.children.length > 0 || this.menu === true;
    },
    isActive() {
      if (this.$route && this.$route.path) {
        let matchingRoute = this.children.find((c) =>
          this.$route.path.startsWith(c.link.path)
        );
        if (matchingRoute !== undefined) {
          return true;
        }
      }
      return false;
    },
  },
  methods: {
    linkClickWithFilter(filter){
      if(this.$route.name !== this.link.name){
        this.$router.push({ name: this.link.name, params: { filter: filter }})
      } else {
        this.$route.params.filter = filter
        EventBus.$emit('filterUpdate', filter)

      }
    },
    addChild(item) {
      const index = this.$slots.default.indexOf(item.$vnode);
      this.children.splice(index, 0, item);
    },
    removeChild(item) {
      const tabs = this.children;
      const index = tabs.indexOf(item);
      tabs.splice(index, 1);
    },
    elementType(link, isParent = true) {
      if (link.isRoute === false) {
        return isParent ? "li" : "a";
      } else {
        return "router-link";
      }
    },
    linkAbbreviation(name) {
      const matches = name.match(/\b(\w)/g);
      return matches.join("");
    },
    linkClick() {
      if(this.$route.name === this.link.name){
        this.$route.params.filter = 'none'
        EventBus.$emit('filterUpdate', 'none')
      }
      if (
        this.autoClose &&
        this.$sidebar &&
        this.$sidebar.showSidebar === true
      ) {
        this.$sidebar.displaySidebar(false);
      }
    },
    collapseMenu() {
      this.collapsed = !this.collapsed;
    },
    collapseSubMenu(link) {
      link.collapsed = !link.collapsed;
    },
  },
  mounted() {
    if (this.addLink) {
      this.addLink(this);
    }
    if (this.link.collapsed !== undefined) {
      this.collapsed = this.link.collapsed;
    }
    if (this.isActive && this.isMenu) {
      this.collapsed = false;
    }

    if(this.opened){
      this.collapsed = false
    }
  },
  destroyed() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
    if (this.removeLink) {
      this.removeLink(this);
    }
  },
};
</script>
<style>

.filters {
  position: absolute;
  margin-top: -34px;
  right: 2px;
  z-index: 1;
}

.filter-tag {
  margin-right: 5px;
  z-index: 1;
  line-height: 5px !important;
  font-size: 10px !important;
  width: 30px;
  height: 15px;
  float: right;
}

.badge-default {
  border-color: #C4C4C4;
  background-color: #C4C4C4;
}

.sidebar .nav li.active > a[data-toggle=collapse] + div .nav .active a:after {
  border-radius: 5px !important;
}

.sidebar .nav li > a, .off-canvas-sidebar .nav li > a {
  border-radius: 5px !important;
}

.sidebar-menu-item {
  cursor: pointer;
}
.sidebar ul.links__nav {
  margin-top: 0;
  padding-top: 10px;
}
</style>
